import React from "react";
import { Title, Container, Button, Badge } from "@bsf/force-ui";
import { Headphones, HelpCircle, StarIcon, NotepadText, BookOpenText, Video } from "lucide-react";
import { __ } from "@wordpress/i18n";

const QuickAccess = () => {
	return (
		<div
			className="box-border uavc-dashboard-quick-access p-4 bg-white rounded-lg shadow-sm"
			style={{
				width: "-webkit-fill-available",
			}}
		>
			<Title
				className="mb-2"
				icon={null}
				iconPosition="right"
				size="xs"
				tag="h3"
				title={__("Quick Access", "ultimate_vc")}
			/>

			<Container
				align="stretch"
				className="p-1 rounded-lg bg-[#F9FAFB] gap-1"
				containerType="flex"
				direction="column"
				gap=""
				justify="start"
				style={{
					width: "100%",
					backgroundColor: "#F9FAFB",
				}}
			>		<Container.Item
					alignSelf="auto"
					className="p-4 bg-white rounded-lg  shadow-sm"
					order="none"
					shrink={1}
				>
					<Button
						className="text-black uavc-remove-ring"
						icon={<BookOpenText />}
						iconPosition="left"
						variant="link"
						onClick={() => {
							window.open(
								"https://ultimate.brainstormforce.com/docs/",
								"_blank"
							);
						}}
					>
						{__("Knowledge Base", "ultimate_vc")}
					</Button>
				</Container.Item>
				<Container.Item
					alignSelf="auto"
					className="p-4 bg-white flex items-center justify-between rounded-lg shadow-sm"
					order="none"
					shrink={1}
				>
					<Button
						className="text-black uavc-remove-ring"
						icon={<Headphones />}
						iconPosition="left"
						variant="link"
						onClick={() => {
							window.open(
								"https://ultimate.brainstormforce.com/support/",
								"_blank"
							);
						}}
					>
						{__("Dedicated Support Team", "ultimate_vc")}
					</Button>
				</Container.Item>
				<Container.Item className="p-4 bg-white rounded-lg shadow-sm">
					<Button
						className="text-black uavc-remove-ring"
						icon={<Video />}
						iconPosition="left"
						variant="link"
						onClick={() => {
							window.open(
								"https://www.youtube.com/watch?v=pJtN81Qdwbk&list=PL1kzJGWGPrW9CDWwdAWrd_9YQsh1z7u6O&index=1",
								"_blank"
							);
						}}
					>
						{__("Watch & Learn", "ultimate_vc")}
					</Button>
				</Container.Item>
			</Container>
		</div>
	);
};

export default QuickAccess;
